import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect } from "react";
import Base from "../../base/views/base";
import RecentCapturedGoodsDashboard from "../../Dashboard/views/RecentCapturedGoodsDashboard";
import { getSessionData } from "../../base/helper/baseHelper";
// eslint-disable-next-line
import CategoryPurchaseDashboard from "../../Dashboard/views/CategoryPurchaseDashboard";
import { getUPCdetailPhysicalInventory } from "../../InventoryManagement/PhysicalInventory/helper/physicalInventoryHelper";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& .MuiPaper-root": {
      backgroundColor: "rgba(255,255,255,0.5)",
      backdropFilter: "blur(6px)",
      borderRadius: "15px",
      padding: "10px",
      marginTop: "1%",
      justifyContent: "center",
      alignItems: "center",
    },
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

export default function Home() {
  const classes = useStyles();
  const storeData = JSON.parse(getSessionData({ key: "store" }));

  const GetUPCdetailPhysicalInventory = async () => {
    try {
      const store = JSON.parse(getSessionData({ key: "store" }));
      await getUPCdetailPhysicalInventory(store?.storeid);
    } catch (error) {}
  };

  useEffect(() => {
    GetUPCdetailPhysicalInventory();
  }, []);

  return (
    <div style={{ display: "flex" }}>
      <Base showBaseMenu={true} showUserManagement>
        <div className={classes.root} style={{ marginTop: "4%" }}>
          {storeData && storeData.store_alias && (
            <Typography
              component="h1"
              variant="h3"
              align="center"
              color="textPrimary"
              gutterBottom
            >
              {storeData.store_alias} - Dashboard
            </Typography>
          )}
          <Grid container spacing={3}>
            <Grid item xs={12} md={7} lg={7}>
              <Paper>
                {/* <CategoryPurchaseDashboard /> */}
                <RecentCapturedGoodsDashboard />
              </Paper>
            </Grid>
            <Grid item xs={12} md={5} lg={5}>
              <Paper>
                <CategoryPurchaseDashboard />
              </Paper>
            </Grid>
          </Grid>
          {/* <Grid container spacing={3}>
            <Grid item xs={12} md={12} lg={12}>
              <Paper>
                <RecentCapturedGoodsDashboard />
              </Paper>
            </Grid>
          </Grid> */}
        </div>
      </Base>
    </div>
  );
}
